// Pure helpers for the team-wide contact lookup (no Firebase imports).
//
// Rows returned by the team-wide fetch are shared via a module cache, so
// tagging must COPY rows, never mutate them. `_teamOwnerName` is a
// display-only field: set on rows the viewing user does NOT own, holding the
// owning agent's first name ("Team" when the owner is unknown). Underscore
// prefix = never persisted; pickers only pass the contact id onward.

const ownerFirstName = (u) => {
  if (!u) return "";
  // users docs write lowercase `firstname` (signup/team tabs); contacts and
  // some legacy docs use camelCase — accept both, then fall back to `name`.
  if (u.firstname) return String(u.firstname).trim();
  if (u.firstName) return String(u.firstName).trim();
  return String(u.name || "").trim().split(/\s+/)[0] || "";
};

export function tagTeamContacts(contacts, users, viewerId) {
  const nameById = new Map(
    (users || []).map((u) => [String(u.id), ownerFirstName(u)]),
  );
  return (contacts || []).map((c) => {
    if (String(c.createdBy) === String(viewerId)) return c;
    return { ...c, _teamOwnerName: nameById.get(String(c.createdBy)) || "Team" };
  });
}
